import { useEffect, useState } from 'react'
import { Button, Card } from 'antd'

import { UPDATE_NOTE, setToken } from './services/notes'
import { GET_ALL_BLOGS } from './services/blogs'
import Login from './login'

const { Meta } = Card
const App = () => {
  const [blogs, setBlogs] = useState([])
  const [userInfo, setUserInfo] = useState(null)
  useEffect(() => {
    // getData()
    const userInfo = localStorage.getItem('loggedNoteappUser')
    if (userInfo) {
      const user = JSON.parse(userInfo)
      setUserInfo(user)
      setToken(user.token)
    }
  }, [])

  const addBlog = async (event) => {
    event.preventDefault()
    await UPDATE_NOTE({
      content: 'note32node',
      important: false,
      id: '6656ecd9c94ef0dd2ed9e7a0',
    })
    // const noteObject = {
    //   title: randomString(10),
    //   author: randomString(6),
    //   url: randomString(32),
    //   likes: 0,
    // }
    // await ADD_BLOG(noteObject)

    // // setBlogs(blogs.concat(newNote))
    // getData()
  }

  // eslint-disable-next-line no-unused-vars
  const getData = async () => {
    const data = await GET_ALL_BLOGS()
    setBlogs(data)
  }

  const handleLogout = async () => {
    localStorage.removeItem('loggedNoteappUser')
    setUserInfo(null)
  }

  return (
    <div className="" style={{ height: '100vh', background: 'pink' }}>
      <icon-affirm></icon-affirm>
      123
    </div>
  )

  return (
    <div>
      {!userInfo ? (
        <Login changeUserInfo={setUserInfo} />
      ) : (
        <div>
          <h1>Blogs</h1>
          <Button onClick={addBlog}>add Blog</Button>
          <div style={{ display: 'flex', gap: 10 }}>
            {blogs.map((blog) => (
              <Card
                hoverable
                style={{ width: 240 }}
                key={blog.id}
                cover={
                  <img
                    alt="example"
                    src="https://os.alipayobjects.com/rmsportal/QBnOOoLaAfKPirc.png"
                  />
                }
              >
                <Meta title={blog.title} description={blog.url} />
              </Card>
            ))}
          </div>
          <p>{userInfo.username}</p>
          <Button onClick={handleLogout}>登出</Button>
        </div>
      )}
    </div>
  )
}

export default App
